import React, { useContext } from "react";
import { t } from "ttag";

import { ReactivatedContext } from "../../../context";
import { buildLocalImage } from "../../../utils/buildLocalImage";
import { ModalFooter } from "../ModalFooter/ModalFooter";
import { OptionTile } from "../Screen/OptionTile";
import { hub } from "../engine";
import type { Action, AppState, ScreenOption, SpokeId } from "../engine";

import styles from "./Hub.module.scss";

export type HubProps = {
    state: AppState;
    dispatch: React.Dispatch<Action>;
    onShowOfferDetails: () => void;
};

const SPOKE_IMG = {
    width: 1200,
    height: 1200,
    mimetype: "image/webp",
    alt: "",
};

export const Hub = ({ state, dispatch, onShowOfferDetails }: HubProps) => {
    const { STATIC_URL } = useContext(ReactivatedContext);
    const base = `${STATIC_URL}suite-builder/hub/`;
    const spokeImages: Record<SpokeId, ReturnType<typeof buildLocalImage>> = {
        cooking: buildLocalImage(`${base}cooking.webp`, SPOKE_IMG),
        refrigeration: buildLocalImage(`${base}refrigeration.webp`, SPOKE_IMG),
        dishwasher: buildLocalImage(`${base}dishwasher.webp`, SPOKE_IMG),
        microwave: buildLocalImage(`${base}microwave.webp`, SPOKE_IMG),
        ventilation: buildLocalImage(`${base}ventilation.webp`, SPOKE_IMG),
    };

    const spokeAsOption = (
        spoke: (typeof hub.spokes)[number],
    ): ScreenOption => ({
        id: spoke.id,
        label: spoke.label,
        image: spokeImages[spoke.id],
        isAccessory: false,
    });

    return (
        <div className={styles.hub}>
            <div className={styles.body}>
                <h2 className={styles.heading}>{t`Choose a category`}</h2>
                <p className={styles.subhead}>
                    {t`Select your preference below. Then, you'll be able to add appliance(s).`}
                </p>
                <div className={styles.tileGrid}>
                    {hub.spokes.map((s) => (
                        <OptionTile
                            key={s.id}
                            option={spokeAsOption(s)}
                            onClick={() =>
                                dispatch({
                                    type: "ENTER_SPOKE",
                                    spoke: s.id,
                                    entry: "populated",
                                })
                            }
                        />
                    ))}
                </div>
            </div>
            <ModalFooter
                state={state}
                onShowOfferDetails={onShowOfferDetails}
            />
        </div>
    );
};
